<template>
  <div class="top clearfix">
    <!-- <div class="left box width200 width120">
      <change-type default="source"></change-type>
    </div> -->
    <div class="left searchBox">
      <!-- 搜索 -->
      <div class="box width200 input-box">
        <search-input
          :placeholder="$t('lang.searchTText')"
          :callback="search"
          :regular="searchReg"
          :value="filter.condition"></search-input>
      </div>
      <div
        class="box filters-toggle"
        @click="filterSectionToggle">
        <i class="icon iconfont">&#xe69c;</i> {{ $t('lang.filters') }}
      </div>
      <!-- clear filter -->
      <div
        v-show="!filterSectionAddBtn && $route.name != 'SourceMap' && !showResetFilter"
        class="clearFilters"
        @click="resetFilter">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('lang.clearFilter')"
          placement="top-start">
          <i class="icon iconfont icon-a-RestoreFilter"></i>
        </el-tooltip>
      </div>
      <span
        class="addBtn iconfont sourceAddIcon "
        @click="addSource"
        v-show="!filterSectionAddBtn && $route.name != 'SourceMap'"></span>
    </div>
    <div
      class="filters-section left"
      v-show="filterSection">
      <!-- status -->
      <div class="box set">
        <drop-menu-select
          :data="statusData"
          :typeVal="'status'"
          :class="{'filterHighBlur': hasCheckedStatus}"
          :hasOnGoing="$route.name == 'SourceMap'? false : openOnGoingEvent"
          :title="$t('lang.status')"
          :callback="changeFilter">
        </drop-menu-select>
      </div>
      <!-- bookmark -->
      <div
        class="box"
        @click="openBookmarkList"
        v-if="$route.name != 'SourceMap' && !hideBookmark">
        <book-mark
          :callback="changeFilter"
          :class="{'filterHighBlur': filter.bookmardIds != ''}"
          :from="{ Unclassified: true }"
          :defaultKeys="defaultBookmark"></book-mark>
      </div>
      <!-- type -->
      <div class="box set">
        <drop-menu-select
          :data="typeData"
          :typeVal="'type'"
          :class="{'filterHighBlur': hasCheckedType}"
          :title="$t('lang.Type')"
          :callback="changeFilter">
          <template
            slot-scope="iconVal"
            slot="deviceIcon">
            <span
              v-html="iconVal.iconVal"
              class="iconfont deviceIcon"></span>
          </template>
        </drop-menu-select>
      </div>
      <!-- 排序 -->
      <div
        class="box last-select"
        v-show="$route.name != 'SourceMap'">
        <select-menu
          :data="selectBySort"
          :callback="changeSort"
          :selectVal="selectSort"></select-menu>
      </div>
      <!-- clear filter -->
      <div
        v-show="filterSectionAddBtn && $route.name != 'SourceMap' && !showResetFilter"
        class="clearFilters"
        @click="resetFilter">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('lang.clearFilter')"
          placement="top-start">
          <i class="icon iconfont icon-a-RestoreFilter"></i>
        </el-tooltip>
      </div>
      <span
        class="addBtn iconfont sourceAddIcon"
        @click="addSource"
        v-show="filterSectionAddBtn && $route.name != 'SourceMap'"></span>
    </div>
    <div class="right rightFl">
      <!-- 分页 -->
      <div
        class="info icon"
        v-show="$route.name != 'SourceMap'">
        <Pagination
          ref="sourcePagination"
          @current-change="handleCurrentChange"
          :current-page="filter.pageNum"
          :pageSizes="[10, 15, 20, 50, 100]"
          :pageSize="filter.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          layout="prev, pageF, next, pageL, nowSize, jumper">
        </Pagination>
      </div>
      <div
        class="info map"
        v-show="$route.name == 'SourceMap' && !newSourcesPage">
        {{ $t('lang.refreshInterval') }}
        <div class="fresh box">
          <select-menu
            :data="freshData"
            :noTranslate="true"
            :callback="changeFresh"
            :selectVal="freshTime"></select-menu>
        </div>
        <i class="red"></i>
        <i class="green"></i>
        <i class="gray"></i>
        <span class="xy">{{ $t('lang.coordinate') }}(
          <span class="red">{{ mapNum.livingPosition }}</span>
          /<span class="green">{{ mapNum.onlinePosition }}</span>
          /<span class="gray">{{ mapNum.offlinePosition }}</span>
          <span v-show="mapNum.noPosition>0">&nbsp;{{ $t('lang.ReceiverError') }}: {{mapNum.noPosition}}</span>)
        </span>
      </div>
      <!-- 列表切换 -->
      <div
        class="info icon"
        v-if="!newSourcesPage">
        <i
          class="iconfont sourceInfoIcon"
          :class="{ tabActive: $route.name == 'SourceList' || $route.name == 'NewSourceList'}"
          @click="jump('SourceList')"></i>
      </div>
      <div
        class="info icon"
        v-if="!newSourcesPage">
        <i
          class="iconfont sourceListIcon"
          :class="{ tabActive: $route.name == 'SourceContent' }"
          @click="jump('SourceContent')"></i>
      </div>
      <div
        class="info icon"
        v-if="!newSourcesPage">
        <el-dropdown
          @command="changeSize"
          placement="bottom-end">
          <span class="el-dropdown-link">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu
            slot="dropdown"
            class="selectSizeBox">
            <el-dropdown-item
              command="l"
              :class="[showSizeClass == 'l' ? 'green' : '']">
              <span
                class="iconfont icon-largesize"
                style="padding-right: 8px"></span>{{ $t('lang.largeSize') }}</el-dropdown-item>
            <el-dropdown-item
              command="m"
              :class="[showSizeClass == 'm' ? 'green' : '']">
              <span
                class="iconfont"
                style="padding-right: 8px">&#xe63d;</span>{{ $t('lang.mediumSize') }}</el-dropdown-item>
            <el-dropdown-item
              command="s"
              :class="[showSizeClass == 's' ? 'green' : '']">
              <span
                class="iconfont"
                style="padding-right: 8px">&#xe6ef;</span>{{ $t('lang.smallSize') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div
        class="info icon"
        v-if="!newSourcesPage">
        <i
          class="iconfont i-map"
          :class="{ tabActive: $route.name == 'SourceMap' }"
          @click="jump('SourceMap')"></i>
      </div>
      <div
        class="info icon"
        v-if="!newSourcesPage">
        <i
          class="iconfont icon-zidongdingwei"
          :class="{ tabActive: $route.name == 'SourceMapTrack' }"
          @click="chooseTrack">
        </i>
      </div>
    </div>
    <!-- <map-track
      :info="trackAlert"
      v-if="trackAlert.show"></map-track> -->
    <!-- 轨迹弹框 -->
    <component
      :is="trackAlertWrap"
      :info="trackAlert"
      v-if="trackAlert.show"
    ></component>
    <!-- addSource -->
    <component
      :is="addSourceWrap"
      v-if="add.show"
      :data="add"
      @queryList="queryInfo"
    ></component>
  </div>
</template>
<script>
import Bus from '@/assets/js/vueBus.js'
import { mapMutations, mapState } from 'vuex'
import { MySourceStatus, MySourceType, SelectBySorts } from '@/config'
// import ChangeType from './changeType'
import SearchInput from '@/components/Search'
import BookMark from '@/components/bookMark'
import SelectMenu from '@/components/SelectMenu'
import Pagination from '@/components/Pagination'
// import AddSource from './dialog/addSource'
import DropMenuSelect from '@/components/dropMenuSelect'
import { mySourceAnalyze } from '@/assets/js/googleAnalyze/mySource.js'
// import mapTrack from './dialog/mapTrackAlert'
export default {
  name: 'sourceTop',
  components: {
    SearchInput,
    BookMark,
    SelectMenu,
    Pagination,
    // AddSource,
    DropMenuSelect
    // mapTrack
    // ChangeType
  },
  props: {
    query: Function,
    mapNum: {
      type: Object,
      default: () => {
        return {
          livingPosition: 0,
          totalPosition: 0,
          noPosition: 0
        }
      }
    },
    newSourcesPage: {
      type: Boolean,
      default: false
    }
  },
  computed: mapState({
    // 映射
    userBehaviors: state => (state.userBehaviors ? state.userBehaviors : {}),
    showSizeClass () {
      return this.$store.state.common.showDeviceSize
    },
    openOnGoingEvent () {
      return this.$store.state.common.baseUrl.openOnGoingEvent
    },
    // 有搜索信息或者筛选信息非初始化，则显示重置筛选标
    showResetFilter () {
      return this.filter.condition === '' && this.statusTypeAll && this.filter.bookmardIds === 'all' && this.typeTypeAll
    },
    hasCheckedStatus () {
      const { living, online, offline, noCamera, onGoingEvent } = this.filter
      const flag = living || online || offline || noCamera || onGoingEvent
      return flag
    },
    hasCheckedType () {
      const { pack, anywhere, gridPack, gridSdi, ext } = this.filter
      const flag = pack || anywhere || gridPack || gridSdi || ext
      return flag
    },
    hasCheckedBookmark () {
      const arr = this.typeData.filter(v => v.isChecked === true)
      return arr.length > 0
    }
  }),
  data () {
    return {
      trackAlert: {
        show: false
      }, // 轨迹弹框是否显示
      statusData: JSON.parse(JSON.stringify(MySourceStatus)),
      typeData: JSON.parse(JSON.stringify(MySourceType)),
      // 不过滤空格，保留 source name 中间的空格（首尾空格在 search() 时再 trim）
      searchReg: /(?!)/g,
      selectBySort: SelectBySorts,
      pageSize: 15,
      total: 0,
      freshTime: 60,
      freshData: [
        // map更新数据
        { label: 60, value: 60 },
        { label: 30, value: 30 },
        { label: 20, value: 20 },
        { label: 10, value: 10 }
      ],
      filter: {
        // 筛选过滤参数
        living: true,
        online: true,
        offline: true,
        noCamera: true,
        pack: true,
        anywhere: true,
        gridPack: true,
        gridSdi: true,
        ext: true,
        pageNum: 1,
        pageSize: 15,
        condition: '',
        bookmardIds: 'all',
        unClassified: true,
        token: true,
        onlineFirst: true,
        liveFirst: false,
        globalGrid: true,
        gridViaToken: true,
        onGoingEvent: false
      },
      selectSort: '', // 下拉排序
      defaultBookmark: {
        // 默认bookmark选中的值l
        bookmardIds: ['all'],
        token: true,
        unClassified: true
      },
      add: {
        // add ext
        show: false
      },
      show: false,
      lastFilterStatus: [],
      lastFilterType: [],
      showFilter: false,
      filterSection: false,
      filterSectionAddBtn: false,
      // 判断各选项是否全选状态
      statusTypeAll: true,
      typeTypeAll: true,
      hideBookmark: false,
      trackAlertWrap: null,
      addSourceWrap: null
    }
  },
  created () {
    const onGoing = this.statusData.filter(v => v.value == 'onGoingEvent')
    if (!onGoing.length && this.openOnGoingEvent && this.$route.name !== 'SourceMap') {
      this.statusData.push({
        value: 'onGoingEvent',
        label: 'going',
        color: 'yello',
        isChecked: false
      })
    }
    if (this.$route.name == 'SourceMap') {
      const extIndex = this.typeData.findIndex(v => v.value == 'ext')
      if (extIndex >= 0) {
        this.typeData.splice(extIndex, 1)
      }
    }

    this.queryInfo(this.$route.name, 'init')
    Bus.$on('updateMySource', () => {
      this.queryInfo(this.$route.name, 'init')
    })
    Bus.$on('updateSourceListInfo', () => {
      this.queryInfo(this.$route.name)
    })
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    Bus.$off('updateMySource')
    Bus.$off('updateSourceListInfo')
  },
  methods: {
    // 搜索函数
    ...mapMutations('common', ['CHANGE_SOURCESize']),
    search (val) {
      mySourceAnalyze('mySourceSearch', this.$route.path) // 谷歌统计
      this.filter.pageNum = 1
      // 仅 trim 首尾空格，保留中间空格以支持含空格的 name 搜索
      this.filter.condition = (val || '').trim()
      this.queryInfo('', 'filter')
    },
    // 点击定位按钮
    async chooseTrack () {
      this.trackAlertWrap = await import('./dialog/mapTrackAlert').then(module => module.default)
      this.trackAlert.show = true
    },
    openBookmarkList () {
      mySourceAnalyze('mySourceBookmarkOpen', this.$route.path) // 谷歌统计
    },
    // 谷歌统计处理
    handleAnalyze (allVal, list, lastArr, type) {
      if (allVal != '' && allVal.all === true) {
        mySourceAnalyze(`${type}AllSelected`, this.$route.path) // 谷歌统计
        this[lastArr] =
          type == 'mySourceStatus' ? ['online', 'noCamera', 'living', 'offline'] : [
            'pack',
            'anywhere',
            'gridPack',
            'gridSdi',
            'ext',
            'gridViaToken',
            'globalGrid'
          ]
        return
      }
      if (allVal != '' && allVal.all === false) {
        mySourceAnalyze(`${type}AllUnselect`, this.$route.path) // 谷歌统计
        this[lastArr] = []
        return
      }
      list.map((v, i) => {
        if (!this[lastArr].includes(v)) { mySourceAnalyze(`${type}${v}Selected`, this.$route.path) } // 谷歌统计
      })
      this[lastArr].map((v, i) => {
        if (!list.includes(v)) { mySourceAnalyze(`${type}${v}Unselect`, this.$route.path) } // 谷歌统计
      })
      this[lastArr] = list
    },
    // 筛选
    changeFilter (obj, allVal, list, type, isSelected) {
      // 谷歌统计
      if (list && type == 'status') {
        this.handleAnalyze(allVal, list, 'lastFilterStatus', 'mySourceStatus')
      }
      if (list && type == 'type') {
        this.handleAnalyze(allVal, list, 'lastFilterType', 'mySourceType')
      }
      if (allVal === 'hideBookmark') {
        this.hideBookmark = true
        return
      }
      Object.keys(obj).map(v => {
        // this.filter 过滤参数对象
        this.filter[v] = obj[v]
      })
      if (type == 'status' || type == 'type') {
        if (allVal.all) {
          type == 'status' ? this.statusTypeAll = true : this.typeTypeAll = true
        } else {
          const arr = []
          Object.keys(obj).map(v => {
            const obj1 = {
              value: v,
              isChecked: obj[v] || false
            }
            arr.push(obj1)
          })
          type == 'status' ? this.checkStatusTypeAll(arr) : this.checkTypeAll(arr)
        }
      }
      this.filter.pageNum = 1
      this.queryInfo()
      // this.$route.name != 'SourceMap' && this.queryInfo() // 筛选后查询接口
    },
    // 重置各个filter选项
    resetFilter () {
      this.filter = {
        living: true,
        online: true,
        offline: true,
        noCamera: true,
        pack: true,
        anywhere: true,
        gridPack: true,
        gridSdi: true,
        ext: true,
        pageNum: 1,
        pageSize: 15,
        condition: '',
        bookmardIds: 'all',
        unClassified: true,
        token: true,
        onlineFirst: true,
        liveFirst: false,
        globalGrid: true,
        gridViaToken: true,
        onGoingEvent: false
      }
      this.lastFilterStatus = []
      this.lastFilterType = []
      // 用来处理筛选选中的状态
      this.statusData.map((v, k) => {
        const obj = v
        obj.isChecked = this.filter[v.value] || false
        this.$set(this.statusData, k, obj)
      })
      this.typeData.map((v, k) => {
        const obj = v
        obj.isChecked = this.filter[v.value] || false
        this.$set(this.typeData, k, obj)
      })
      this.selectSort = this.$options.filters.FORMATSORT(this.filter)
      // bookmark
      this.defaultBookmark.bookmardIds = this.filter.bookmardIds ? this.filter.bookmardIds == 'all' ? ['all'] : this.filter.bookmardIds.split(',') : []
      this.filter.unClassified && this.defaultBookmark.bookmardIds.push('unClassified')
      this.filter.token && this.defaultBookmark.bookmardIds.push('token')
      this.show = true
      this.filter.pageSize = 15
      this.statusTypeAll = true
      this.typeTypeAll = true
      this.queryInfo()
    },
    // 排序
    changeSort (val) {
      mySourceAnalyze(`mySourceSort${val}`, this.$route.path) // 谷歌统计
      this.filter.pageNum = 1
      this.filter.onlineFirst = val == 'onlineFirst'
      this.filter.liveFirst = val == 'liveFirst'
      this.$route.name != 'SourceMap' && this.queryInfo()
    },
    // 分页
    handleCurrentChange (val) {
      this.filter.pageNum = val
      this.queryInfo()
    },
    handleSizeChange (val) {
      this.filter.pageSize = val
      this.filter.pageNum = 1
      this.queryInfo()
    },
    // 更改刷新时间
    changeFresh (val) {
      this.freshTime = val
      this.queryInfo(this.$route.name, 'frequency')
    },
    // 路由跳转
    jump (val, type) {
      mySourceAnalyze(`mySource${val}`, this.$route.path) // 谷歌统计
      if (val == this.$route.name) return
      const routeName = val || this.$route.name
      this.$router.push({ name: routeName }).catch(() => {})
    },
    // 地图所需数据
    emitMapData (flag) {
      const obj = {
        query: this.filter,
        freshTime: this.freshTime,
        queryFlag: flag
      }
      this.$emit('filterMap', obj)
      this.show = true
    },
    async initInfo () {
      try {
        const routeName = this.$route?.name || 'SourceContent'
        const { apiPath, apiType } = this.getRouteConfig(routeName)

        const res = await this.axios.post(apiPath, {
          apiType: apiType
        })

        if (res.data.errorCode !== '0x0') return

        this.showFilter = true
        const { param: userBehaviors, content: list } = res.data?.result || { param: null, content: { list: [] } }

        // 处理过滤行为
        if (userBehaviors) this.handleFilterBehavior(userBehaviors)

        // 更新状态和数据
        this.statusData = this.updateCheckedStatus(this.statusData, this.filter)
        this.typeData = this.updateCheckedStatus(this.typeData, this.filter)

        this.checkStatusTypeAll(this.statusData)
        this.checkTypeAll(this.typeData)

        this.selectSort = this.$options.filters.FORMATSORT(this.filter)

        // 处理书签
        this.defaultBookmark.bookmardIds = this.filter.bookmardIds
          ? this.filter.bookmardIds === 'all'
            ? ['all']
            : this.filter.bookmardIds.split(',')
          : []

        if (this.filter.unClassified) this.defaultBookmark.bookmardIds.push('unClassified')
        if (this.filter.token) this.defaultBookmark.bookmardIds.push('token')

        this.show = true
        this.filter.pageSize = 15

        // 路由特定处理
        if (['SourceContent', 'SourceList', 'NewSourceList'].includes(routeName)) {
          this.total = list?.total || 0
          this.query(list)
          this.$emit('sendMySourceSockect', list)
        } else if (routeName === 'SourceMap') {
          this.emitMapData(false)
        }

        Bus.$emit('changeFilter', true)
      } catch (error) {
        console.error('initInfo error:', error)
        Bus.$emit('changeFilter', true)
      }
    },
    async queryInfo (val, type) {
      const routeName = val || this.$route.name
      Bus.$emit('changeFilter', false)

      try {
        if (type === 'init') {
          await this.initInfo()
          return
        }
        if (['SourceContent', 'SourceList', 'NewSourceList'].includes(routeName)) {
          const data = {
            ...this.filter,
            token: this.filter.anywhere,
            globalGrid: this.filter.gridSdi || this.filter.gridPack,
            gridViaToken: this.filter.gridSdi || this.filter.gridPack
          }

          if (routeName === 'SourceList' || routeName === 'NewSourceList') {
            data.battery = true
            data.bookmarks = true
          }

          const apiPath = routeName === 'NewSourceList'
            ? '/ccp/tvucc-user/userDevice/pageUserSourceNew'
            : '/ccp/tvucc-user/userDevice/pageUserSource'

          const res = await this.axios.post(apiPath, data, {
            contentType: 'application/json;charset=UTF-8',
            isCancelToken: true
          })

          if (res.data.errorCode === '0x0') {
            const result = res.data.result

            // 处理设备版本信息
            result.list.forEach(item => {
              const updateVersion = device => {
                if (device.type === 'T' && device.platform) {
                  device.version = device.releaseStr || device.version
                }
              }

              if (item.sonDevice) item.sonDevice.forEach(updateVersion)
              updateVersion(item)
            })

            this.total = result.total || 0
            this.query(result)
            this.$emit('sendMySourceSockect', result)
          }
        } else if (routeName === 'SourceMap') {
          this.emitMapData(type !== 'frequency')
        }

        Bus.$emit('changeFilter', true)
      } catch (error) {
        // console.error('queryInfo error:', error)
        console.log(error)
        Bus.$emit('changeFilter', true)
      }
    },

    getRouteConfig (routeName) {
      // 提取路由相关配置
      const ROUTE_CONFIG = {
        SourceContent: {
          apiPath: '/ccp/tvucc-user/userDevice/mySourceWithInit',
          apiType: 'SourceList'
        },
        NewSourceList: {
          apiPath: '/ccp/tvucc-user/userDevice/mySourceWithInitNew',
          apiType: 'SourceList'
        }
      }
      return ROUTE_CONFIG[routeName] || {
        apiPath: '/ccp/tvucc-user/userDevice/mySourceWithInit',
        apiType: routeName || 'SourceList'
      }
    },
    // 提取状态和类型过滤逻辑
    handleFilterBehavior (userBehaviors) {
      const statusKeys = ['living', 'noCamera', 'offline', 'online']
      const typeKeys = ['pack', 'anywhere', 'gridPack', 'gridSdi', 'ext']

      // 处理状态过滤
      this.lastFilterStatus = statusKeys.filter(key => userBehaviors[key])

      // 处理类型过滤
      this.lastFilterType = typeKeys.filter(key => userBehaviors[key])

      // 更新filter对象
      Object.keys(this.filter).forEach(v => {
        if (userBehaviors.hasOwnProperty(v)) {
          this.filter[v] = userBehaviors[v]
        }
      })
    },
    // 提取数据项检查逻辑
    updateCheckedStatus (dataArray, filter) {
      return dataArray.map(item => ({
        ...item,
        isChecked: filter[item.value] || false
      }))
    },
    async addSource () {
      // 添加外部视频源
      this.addSourceWrap = await import('./dialog/addSource').then(module => module.default)
      this.add.show = true
      mySourceAnalyze('mySourceAddExtOpen', this.$route.path) // 谷歌统计
    },
    filterSectionToggle () {
      this.filterSection = !this.filterSection
    },
    handleResize () {
      if (document?.body?.clientWidth > 1499) {
        this.filterSection = true
        this.filterSectionAddBtn = true
      }

      if (document?.body?.clientWidth < 1500) {
        this.filterSection = false
        this.filterSectionAddBtn = false
        $('.bookmarkList-cascader').hide()
      }
    },
    changeSize (command) {
      this.CHANGE_SOURCESize(command)
      switch (command) {
        case 's':
          mySourceAnalyze('mySourceChangeSmall', this.$route.path)
          break
        case 'm':
          mySourceAnalyze('mySourceChangeMedium', this.$route.path)
          break
        case 'l':
          mySourceAnalyze('mySourceChangeLarge', this.$route.path)
      }
    },
    checkStatusTypeAll (val) {
      // 判断其中online，noCamera，living， offline 四个数据是否都为true，如果都为true，则all为true
      // 仅做只读 filter/every 判断，无需 JSON 深拷贝
      const statusArr = val.filter(v => v.value != 'onGoingEvent' && v.value != 'all')
      this.statusTypeAll = statusArr.every(v => v.isChecked)
    },
    checkTypeAll (val) {
      // 判断其中pack，anywhere，gridPack，gridSdi，ext 五个数据是否都为true，如果都为true，则all为true
      const typeArr = val.filter(v => v.value != 'all')
      this.typeTypeAll = typeArr.every(v => v.isChecked)
    }
  },
  watch: {
    $route (to, from) {
      // 切换及后退会触发路由变化
      this.queryInfo(to.name, 'frequency')
    }
  }
}
</script>
<style lang="less" scoped>
.top {
  margin-bottom: 24px;
}
.green {
  color: #33ab4f;
}
.deviceIcon {
  width: 12px;
  margin: 0 8px 0 15px;
  font-size: 16px;
  float: left;
}
@media (min-width: 1501px) and (max-width: 1700px) {
  .left {
    .box {
      width: 134px!important;
      margin-right: 15px;
      position: relative;

      &.width200 {
        margin-right: 10px!important;
        margin-left: 10px!important;
      }
    }
  }
}

@media (max-width: 917px) {
  .left {
    .box {
      margin-right: 10px;

      &.width200 {
        width: 163px !important;
      }
    }
  }
}

.top {
  .sourceAddIcon {
    &:before {
      content: '\e602';
      font-size: 18px;
      cursor: pointer;
    }
  }
  .left {
    float: left;

    .input-box {
      margin-right: 15px;
    }
  }

  .right {
    float: right;
    margin-top: 0;
    &.rightFl {
      height: 32px;
      line-height: 32px;
    }
    .info {
      float: left;
    }

    .map {
      i {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 12px;
        margin-left: 3px;
        vertical-align: middle;
        &.red {
          background: #d03f39;
        }

        &.green {
          background: #33ab4f;
        }

        &.gray {
          background: #999;
        }
      }

      .fresh {
        width: 70px;
        display: inline-block;
        margin-right: 5px;
      }

      .xy {
        margin-left: 5px;
        color: #999;
        .red {
          color: #d03f39;
        }
        .green {
          color: #33ab4f;
        }
        .gray {
          color: #999;
        }
      }
    }
    .icon {
      margin-left: 10px;
      height: 32px;
      color: #999;

      .el-dropdown-link {
        cursor: pointer;
        color: #dbdbdb;
      }

      i {
        position: relative;
        // top: -3px;

        &:before {
          font-size: 28px;
        }

        &.tabActive {
          color: #dbdbdb;
        }
      }

      .el-icon-arrow-down {
        // top: 6px;
        left: -5px;
      }

      .el-icon-arrow-down:before {
        font-size: 8px;
        font-weight: 900;
      }
    }
  }

  .box {
    ::v-deep .select-box {
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
  }

  .sourceListIcon:before {
    content: '\E684';
    font-size: 24px;
    cursor: pointer;
  }

  .sourceInfoIcon:before {
    content: '\E701';
    font-size: 24px;
    cursor: pointer;
  }
}

.filters-toggle {
  border: 1px solid #666666 !important;
  height: 32px;
  line-height: 32px;
  border-radius: 5px;
  cursor: pointer;
  color: #999999;
  width: 100px !important;
  display: none !important;
  .iconfont {
    font-size: 14px;
  }
}

.filters-section {
  .box {
    width: 160px;
    margin-right: 15px;
    position: relative;
    float: left;

    &.set {
      height: 32px;
      line-height: 32px;
    }

    &.width200 {
      margin-right: 20px;
    }
    &.width120 {
      width: 120px;
    }

    ::v-deep .el-dropdown {
      width: 100%;
      height: 32px;
    }

    ::v-deep .el-dropdown .el-button.el-button--primary {
      padding: 9px 20px;
    }

    ::v-deep .tree-btn {
      padding: 6px 20px;
    }

    ::v-deep .tree {
      top: 36px;
    }
  }
}
.clearFilters {
  float: left;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  margin-right: 12px;
  color: #fff;
  padding: 0 8px;
  border-radius: 4px;
  background: #5cb85c;
  .iconfont {
    font-size: 20px;
  }
}
.addBtn {
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  height: 32px;
  line-height: 32px;
}
@media (max-width: 1500px) {
  .el-select {
    width: 100% !important;
    margin-right: 0;
  }

  .filters-toggle {
    display: inline-block !important;
    margin-right: 12px;
  }

  .filters-section {
    display: flex;
    position: relative;
    top: 10px;
    z-index: 99;
    left: 0;
    width: 100%;
    .box {
      width: 100%;

      .select-box {
        width: 100%;
        ::v-deep .el-select {
          width: 100% !important;
        }
      }
    }
    .last-select {
      margin-right: 0px;
    }
  }

  .left {
    display: flex;
  }

  .top {
    position: relative;
    .rightFl {
      position: absolute;
      right: 0;
    }
  }

  .iconfont {
    // padding-top: 5px;
    padding-left: 2px;
  }
}

@media (max-width: 1130px) {
  .top {
    .left {
      .filters-section {
        width: 100%;

        .box {
          width: 100%;

          .select-box {
            width: 100%;

            .el-select {
              width: 100%;
            }
          }
        }
      }
    }

    .filters-section {
      position: relative;
      display: block;
      left: 0;
      top: 0;
      //width: auto;
      .box {
        width: 100%;
        margin-top: 5px;
      }

      .select-box {
        width: 100%;

        ::v-deep .el-select {
          width: 100%;
        }
      }
    }

    .rightFl {
      position: relative;
      // float: left;
      // margin-top: 5px;
    }

    .box.set {
      ::v-deep .el-select {
        width: 100%;
      }
    }
  }

  .el-select {
    width: 100% !important;
  }
}
@media (max-width: 870px) {
  .top {
    .rightFl {
      position: relative;
      float: left;
      margin-top: 5px;
    }
  }
}

::v-deep .selectSizeBox {
  top: 20px;
  left: 50px;
}
</style>
